<template>
  <v-divider
    class="border-opacity-100 pb-5"
    style="border-top: 1px dotted #00cae3"
  ></v-divider>
  <div v-show="props.headingName">
    {{ props.headingName }}<span style="color: #00cae3">Select All</span>
  </div>
  <div>
    {{ props.categoryName }} <span style="color: #00cae3">Select All</span>
  </div>
  <div class="checkbox-grid">
    <div v-for="(row, rowIndex) in props.refinedCheckboxesName" :key="rowIndex">
      <!-- <div v-for="(checkbox, index) in row" :key="index" class="checkbox-item"> -->
      <input type="checkbox" :id="row.value" />
      <label style="margin-left: 5px" :for="checkbox">{{ row.key }}</label>
    </div>
    <!-- </div> -->
  </div>
</template>
<script setup>
import { defineProps, watchEffect } from "vue";

const props = defineProps({
  headingName: {
    type: String,
  },
  categoryName: {
    type: String,
  },
  refinedCheckboxesName: {
    type: Object,
  },
});

watchEffect(() => {
  console.log(props, " props");
});
</script>
<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.checkbox-item {
  display: flex;
  align-items: center;
}
.checkbox-item label {
  margin-left: 5px;
}
</style>
